<script>
import AMapLoader from "@amap/amap-jsapi-loader";
window._AMapSecurityConfig = {
  securityJsCode: "8e9c248f99df3ed6ea243177e37306d1", // 安全密钥
};

import { httpAction } from "@/api/manage";
let AMap = null;
let mapInstance = null;
var markers = [];
var icon = null;
var infoWindow = null;
var infoWindowImei = null;
export default {
  name: "",
  props: {},
  components: {},
  mixins: [],
  data() {
    return {
      dataList: [],
      checkAll: false,
      checkedCities: [],
      isIndeterminate: false,
      map: null,
      AMap: null,
      dataSet: new Set(),
      dataListShow: true,
      deviceTab: [],
      deviceStatus: 2,
      tabShow: true,
    };
  },
  methods: {
    getStaffInfo(status) {
      httpAction("/tq/getDeviceStatusCount", {}, "post").then((res) => {
        if (res.code !== 200) return this.$message.warning(res.msg);
        this.deviceTab = [
          { label: "全部 (" + res.data.deviceCount + ")", value: 2 },
          { label: "在线 (" + res.data.onlineCount + ")", value: 1 },
          { label: "离线 (" + res.data.offlineCount + ")", value: 0 },
          { label: "未激活 (" + res.data.inactiveCount + ")", value: -1 },
        ];
      });
      httpAction("/tq/getDeviceStatus", { status }, "post").then((res) => {
        if (res.code !== 200) return this.$message.warning(res.msg);
        this.dataList = res.data.map((item, index) => {
          return {
            ...item,
            id: index,
          };
        });
        markers.forEach((item) => {
          mapInstance.remove(item);
        });
        markers = [];
        this.dataSet = new Set();
        if (this.dataList.length) {
          this.checkAll = true;
          this.checkedCities = [0];
          this.isIndeterminate = true;
          this.getMarker(this.dataList[0].imei, true);
        }
      });
    },
    checkedStatusHandler(val) {
      if (this.deviceStatus == val) return;
      this.deviceStatus = val;
      this.isIndeterminate = false;
      this.checkAll = false;
      // this.checkedCities = [];
      this.getStaffInfo(val);
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.dataList.map((item) => item.id) : [];
      if (val && markers.length < this.dataList.length) {
        this.dataList.forEach((item, index) => {
          if (index == 0) this.getMarker(item.imei, true);
          if (index != 0 && !this.dataSet.has(item.imei))
            this.getMarker(item.imei);
        });
      }
      if (val && markers.length === this.dataList.length) {
        this.getMarker(this.dataList[0].imei, true);
        markers.forEach((item, index) => {
          item.show();
        });
      }
      if (!val) {
        this.isIndeterminate = val;
        infoWindow.close();
        // mapInstance.clearMap();
        markers.forEach((item) => {
          item.hide();
        });
      }
    },
    handleCheckedCitiesChange(value) {
      this.checkedCities = value.sort((a, b) => a - b);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.dataList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.dataList.length;
    },

    // 初始化地图
    initMap() {
      if (mapInstance) return mapInstance;
      return AMapLoader.load({
        key: "c98add164435e1dd4beff2d292a4fffb", // 申请好的Web端开发者Key，首次调用 load 时必填
        // key: "5e8d33843fc45ecb10667ac5aeb46af1",
        version: "2.0",
        plugins: ["AMap.convertFrom"],
      })
        .then((aMap) => {
          AMap = aMap;
          mapInstance = new AMap.Map("container", {
            zoom: 13.4,
            center: [116.532645, 40.101266],
            mapStyle: "amap://styles/66382f6340493a41e17e609d48df5b08",
            resizeEnable: true,
          });
          icon = new AMap.Icon({
            size: new AMap.Size(25, 30),
            image:
              "https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/staff.png",
            imageSize: new AMap.Size(25, 30),
            // imageOffset: new AMap.Pixel(-95, -3),
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getMarker(imei, bool) {
      if (imei === infoWindowImei) {
        infoWindow.close();
        for (let i = 0; i < markers.length; i++) {
          const item = markers[i];
          if (item._opts.imei == imei && item._opts.visible) {
            markers[i].hide();
            return;
          }
        }
      }
      for (let i = 0; i < markers.length; i++) {
        const item = markers[i];
        if (item._opts.imei == imei && item._opts.visible) {
          markers[i].hide();
          // this.dataSet.delete(item);
          i--;
          return;
        } else if (item._opts.imei == imei && !item._opts.visible) {
          markers[i].show();
        }
      }
      this.dataSet.add(imei);
      this.getGps(imei, bool);
    },
    getGps(imei, bool) {
      httpAction("/tq/getGps", { imei }, "post").then(async (res) => {
        if (res.code !== 200) return this.$message.warning(res.msg);
        let res1 = await httpAction("/tq/getDeviceOther", { imei }, "post");
        var marker;
        new AMap.convertFrom(
          [res.data.longitude, res.data.latitude],
          "gps",
          function (info, convertFromResult) {
            marker = new AMap.Marker({
              position: new AMap.LngLat(
                convertFromResult.locations[0].lng,
                convertFromResult.locations[0].lat
              ),
              // anchor: "bottom-center",
              icon: icon,
              offset: new AMap.Pixel(-13, -30),
              imei: imei,
            });

            marker.setTitle(res.data.deviceName);
            httpAction(
              "/tq/getGpsAddr",
              { lat: res.data.latitude - 0, lon: res.data.longitude - 0 },
              "post"
            ).then((result) => {
              if (bool) {
                markers.forEach((item) => {
                  item.setzIndex(12);
                });
                marker.setzIndex(13);
                infoWindow = new AMap.InfoWindow({
                  anchor: "top-center",
                  offset: new AMap.Pixel(0, 0),
                  content:
                    `<div style="width: 350px; font-size: 12px; position: relative; overflow: hidden;">` +
                    `<div style="display: flex; justify-content: space-between; padding: 5px 8px; background-color: #fbfbfb;">` +
                    `
        <div><span>${res.data.imei}&nbsp</span><i class="el-icon-document-copy" onclick="copyImei(${res.data.imei})"></i></div>` +
                    `
      </div>` +
                    `<div style="display: flex; justify-content: space-between; align-items: center; padding: 5px 8px;">` +
                    `
        <div>` +
                    `<div style="display: flex;"><div style="color: #666;">设备名称：</div><div style="color: #333;">${res.data.deviceName}</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">设备类型：</div><div style="color: #333;">无线${res.data.deviceModel}</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">设备状态：</div><div style="color: #333;">在线运动</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">上班打卡：</div><div style="color: #333;">${
                      res1.data.dutyOn || "暂无"
                    }</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">下班打卡：</div><div style="color: #333;">${
                      res1.data.dutyOff || "暂无"
                    }</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">定位类型：</div><div style="color: #333;">卫星定位</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">定位时间：</div><div style="color: #333;">${res.data.gpsTime}</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">通讯时间：</div><div style="color: #333;">${res.data.hbTime}</div></div>` +
                    `</div>` +
                    `<div><img src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/inspectIcon.png" alt=""></div>` +
                    `</div>` +
                    `<div style="padding: 0 8px;">` +
                    `<span><img style="width: 10px; height: 10px;" src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/loaction.png" alt=""></span>` +
                    `<span>${result.data}</span>` +
                    `</div>` +
                    `<div style="padding: 0 8px; width: 80px; display: flex; justify-content: space-around;">` +
                    `<span><img src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/playback.png" alt="" onclick="redirectPlayBack(${imei})"></span>` +
                    `<span><img src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/locationImmediate.png" alt="" onclick="locationImmediate(${imei})"></span>` +
                    `</div>` +
                    `<div style="position:absolute; bottom: -20px; left: 50%; transform: translateX(-50%); width: 0;height: 0; border-top: 10px solid #fff; border-right: 10px solid transparent; border-bottom: 10px solid transparent;  border-left: 10px solid transparent; "></div>` +
                    `</div>`,
                });
                infoWindowImei = imei;

                infoWindow.open(mapInstance, [
                  convertFromResult.locations[0].lng,
                  convertFromResult.locations[0].lat,
                ]);
                mapInstance.setCenter([
                  convertFromResult.locations[0].lng,
                  convertFromResult.locations[0].lat,
                ]);
              }

              marker.on("click", function () {
                markers.forEach((item) => {
                  item.setzIndex(12);
                });
                marker.setzIndex(13);
                infoWindow = new AMap.InfoWindow({
                  anchor: "top-center",
                  offset: new AMap.Pixel(0, 0),
                  content:
                    `<div style="width: 350px; font-size: 12px; position: relative; overflow: hidden;">` +
                    `<div style="display: flex; justify-content: space-between; padding: 5px 8px; background-color: #fbfbfb;">` +
                    `
        <div><span>${res.data.imei}&nbsp</span><i class="el-icon-document-copy" onclick="copyImei(${res.data.imei})"></i></div>` +
                    `
      </div>` +
                    `<div style="display: flex; justify-content: space-between; align-items: center; padding: 5px 8px;">` +
                    `
        <div>` +
                    `<div style="display: flex;"><div style="color: #666;">设备名称：</div><div style="color: #333;">${res.data.deviceName}</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">设备类型：</div><div style="color: #333;">无线${res.data.deviceModel}</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">设备状态：</div><div style="color: #333;">在线运动</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">上班打卡：</div><div style="color: #333;">${
                      res1.data.dutyOn || "暂无"
                    }</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">下班打卡：</div><div style="color: #333;">${
                      res1.data.dutyOff || "暂无"
                    }</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">定位类型：</div><div style="color: #333;">卫星定位</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">定位时间：</div><div style="color: #333;">${res.data.gpsTime}</div></div>` +
                    `<div style="display: flex;"><div style="color: #666;">通讯时间：</div><div style="color: #333;">${res.data.hbTime}</div></div>` +
                    `</div>` +
                    `<div><img src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/inspectIcon.png" alt=""></div>` +
                    `</div>` +
                    `<div style="padding: 0 8px;">` +
                    `<span><img style="width: 10px; height: 10px;" src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/loaction.png" alt=""></span>` +
                    `<span>${result.data}</span>` +
                    `</div>` +
                    `<div style="padding: 0 8px; width: 80px; display: flex; justify-content: space-around;">` +
                    `<span><img src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/playback.png" alt="" onclick="redirectPlayBack(${imei})"></span>` +
                    `<span><img src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/locationImmediate.png" alt="" onclick="locationImmediate(${imei})"></span>` +
                    `</div>` +
                    `<div style="position:absolute; bottom: -20px; left: 50%; transform: translateX(-50%); width: 0;height: 0; border-top: 10px solid #fff; border-right: 10px solid transparent; border-bottom: 10px solid transparent;  border-left: 10px solid transparent; "></div>` +
                    `</div>`,
                });
                infoWindowImei = imei;

                infoWindow.open(mapInstance, [
                  convertFromResult.locations[0].lng,
                  convertFromResult.locations[0].lat,
                ]);
                mapInstance.setCenter([
                  convertFromResult.locations[0].lng,
                  convertFromResult.locations[0].lat,
                ]);
              });
              for (let i = 0; i < markers.length; i++) {
                const item = markers[i];
                if (item._opts.imei == marker._opts.imei) {
                  markers[i].setMap(null);
                  markers.splice(i, 1);
                  i--;
                  break;
                }
              }
              markers.push(marker);
              mapInstance.add(markers);
            });
          }
        );
      });
    },
    copyImei(imei) {
      const input = document.createElement("input");
      input.value = imei;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },
    dataListHandler() {
      this.dataListShow = !this.dataListShow;
    },
    tabShowChange() {
      this.tabShow = !this.tabShow;
    },
    redirectPlayBack(imei) {
      let routeUrl = this.$router.resolve({
        path: "/positioningTrack",
        query: { imei },
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push({
      //   path: "/positioningTrack",
      //   query: {
      //     imei: imei,
      //   },
      // });
    },
    locationImmediate(imei) {
      httpAction(
        "/tq/pushInstruction",
        { imei, insParam: 1, functionId: 2, validTime: 30 },
        "post"
      ).then((res) => {
        if (res.code !== 200) return this.$message.warning(res.msg);
        this.$message.success("操作成功");
      });
    },
  },
  watch: {
    checkedCities: {
      handler(cur, pre) {
        if (cur.length < pre.length && cur[0] !== pre[0]) {
          const checkData = this.dataList.find((item) => item.id === cur[0]);
          if (checkData) this.getGps(checkData.imei, true);
        }
      },
      deep: true,
    },
  },
  computed: {},
  created() {
    this.initMap();
    this.getStaffInfo(2);
  },
  mounted() {
    window.copyImei = this.copyImei;
    window.redirectPlayBack = this.redirectPlayBack;
    window.locationImmediate = this.locationImmediate;
  },
  beforeDestroy() {
    mapInstance && mapInstance.destroy();
    mapInstance = null;
  },
};
</script>
<template>
  <div class="map">
    <div class="tab" v-if="tabShow">
      <div class="tab_top">
        <div class="flexCB tab_top_title">
          <div class="flexCS tab_top_title_left">
            <div class="tab_top_title_icon"></div>
            <div>设备列表</div>
          </div>
          <div class="tab_top_title_right" @click="tabShowChange"></div>
        </div>
        <div class="flex tab_top_allBtn">
          <div class="tab_top_allBtn_item btn_active">全部</div>
          <div class="tab_top_allBtn_item">已绑定</div>
          <div
            class="tab_top_allBtn_item"
            style="border-right: 1px solid #d9d9d9"
          >
            已关注
          </div>
        </div>
        <div class="flexWCA tab_top_allStatusBtn">
          <div
            :class="[
              'tab_top_allStatusBtn_item',
              item.value == deviceStatus ? 'btn_active' : '',
            ]"
            v-for="item in deviceTab"
            :key="item.value"
            @click="checkedStatusHandler(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="tab_bot">
        <div class="tab_bot_title" @click="dataListHandler()">
          <span style="color: #000; margin-right: 5px" v-if="dataListShow"
            >∨</span
          ><span style="color: #000; margin-right: 5px" v-else>∧</span>默认组({{
            dataList.length
          }})
        </div>
        <el-collapse-transition>
          <div v-if="dataListShow">
            <div class="flexCB tab_bot_informationBar">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >设备名称</el-checkbox
              >
              <div style="margin-right: 15px">操作</div>
            </div>
            <div class="tab_bot_list">
              <el-checkbox-group
                v-model="checkedCities"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  v-for="(item, index) in dataList"
                  :label="item.id"
                  :key="item.userId + index"
                  @change="getMarker(item.imei, true)"
                >
                  <div class="flexCB tab_bot_list_checkbox">
                    <div>{{ item.deviceName }}</div>
                    <div class="flexCS tab_bot_list_information">
                      <div
                        class="tab_bot_list_information_run"
                        @click="redirectPlayBack(item.imei)"
                      >
                        <img
                          src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/playback.png"
                          alt=""
                        />
                      </div>
                      <!-- <div class="tab_bot_list_information_list" @click="locationImmediate(item.imei)">
                        <img
                          src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/locationImmediate.png"
                          alt=""
                        />
                      </div> -->
                    </div>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    <div class="tab" style="width: 30px" v-else>
      <div
        style="
          border: 8px solid;
          border-color: transparent transparent transparent #1aa689;
        "
        @click="tabShowChange()"
      ></div>
    </div>
    <div id="container" class="map-container"></div>
  </div>
</template>
<style scoped lang="less">
.flex {
  display: flex;
}
.flexCB {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flexCS {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flexWCA {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}
.tab {
  width: 250px;
  height: 100vh;
  background: #fff;
  padding: 15px 10px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  .tab_top {
    .tab_top_title {
      font-size: 12px;
      font-weight: 600;

      .tab_top_title_icon {
        background: #1aa689;
        width: 5px;
        height: 15px;
        margin-right: 10px;
        border-radius: 5px;
      }
      .tab_top_title_right {
        width: 0;
        height: 0;
        border: 8px solid;
        border-color: transparent #1aa689 transparent transparent;
        cursor: pointer;
      }
    }

    .tab_top_allBtn {
      height: 24px;
      margin-top: 10px;
      box-sizing: border-box;

      .tab_top_allBtn_item {
        width: 33.33%;
        color: rgba(0, 0, 0, 0.85);
        font-size: 12px;
        text-align: center;
        line-height: 24px;
        border: 1px solid #d9d9d9;
        border-right: none;
        cursor: pointer;
      }
      :hover {
        color: #1aa689;
      }
    }

    .tab_top_allStatusBtn {
      margin-top: 10px;
      .tab_top_allStatusBtn_item {
        width: 48%;
        color: rgba(0, 0, 0, 0.85);
        font-size: 12px;
        text-align: center;
        line-height: 24px;
        border: 1px solid #d9d9d9;
        margin-top: 5px;
        cursor: pointer;
      }
      :hover {
        color: #1aa689;
      }
    }
    .btn_active {
      color: #fff !important;
      background: #1aa689;
      border: 1px solid #1aa689 !important;
    }
  }

  .tab_bot {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 10px;
    .tab_bot_title {
      padding-bottom: 10px;
      border-bottom: 1px solid #d9d9d9;
      cursor: pointer;
    }

    .tab_bot_informationBar {
      padding: 10px 0;
      border-bottom: 1px solid #d9d9d9;

      /deep/.el-checkbox__label {
        font-size: 12px !important;
      }
    }

    .tab_bot_list {
      height: calc(100vh - 190px);
      margin-top: 10px;
      padding-right: 6px;
      overflow: auto;
      padding-bottom: 60px;

      /deep/.el-checkbox {
        // display: block !important;
        width: 100%;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        padding: 10px 0;
        margin-right: 0;
      }
      /deep/.el-checkbox__label {
        width: 100%;
        display: block !important;
        margin-right: 0;
      }
      .tab_bot_list_checkbox {
        font-size: 12px;
        color: #1aa689;
        // overflow: hidden;
      }
      .tab_bot_list_information_run {
        margin-right: 6px;
        position: relative;
      }
      .tab_bot_list_information_run:hover::after {
        content: "轨迹回放";
        position: absolute;
        bottom: -10px;
        left: -14px;
      }
      .tab_bot_list_information_list {
        margin-right: 6px;
        position: relative;
      }
      .tab_bot_list_information_list:hover::after {
        content: "立即定位";
        position: absolute;
        bottom: -10px;
        left: -14px;
      }
    }
    .tab_bot_list::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background-color: #f5f5f5;
    }
    .tab_bot_list::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #c1c1c1;
    }
  }
}

.map-container {
  width: 100vw;
  height: 100vh;
  // margin-top: 20px;
}
/deep/.amap-marker-label {
  border: none;
}
</style>
